import React, {useState} from "react";
import {Button} from "antd";

interface LabelProps {
    hiddenCount: number;
    maxItems: number;
    totalCount: number;
}

interface Props<T> {
    items: T[];
    maxItems: number;
    renderItem: (item: T, index: number) => React.ReactNode;
    itemKey?: (item: T, index: number) => React.Key;
    separator?: React.ReactNode;
    toggleSeparator?: React.ReactNode;
    renderExpandLabel: (props: LabelProps) => React.ReactNode;
    renderCollapseLabel: (props: LabelProps) => React.ReactNode;
    buttonClassName?: string;
}

function ExpandableItemList<T>(props: Props<T>) {
    const [expanded, setExpanded] = useState(false);
    const hiddenCount = Math.max(props.items.length - props.maxItems, 0);
    const visibleItems = expanded ? props.items : props.items.slice(0, props.maxItems);
    const labelProps: LabelProps = {
        hiddenCount,
        maxItems: props.maxItems,
        totalCount: props.items.length
    };

    return <>
        {visibleItems.map((item, index) => (
            <React.Fragment key={props.itemKey?.(item, index) ?? index}>
                {index > 0 && props.separator}
                {props.renderItem(item, index)}
            </React.Fragment>
        ))}

        {hiddenCount > 0 && (
            <>
                {visibleItems.length > 0 && (props.toggleSeparator ?? props.separator)}
                <Button
                    className={props.buttonClassName}
                    size={"small"}
                    type={"link"}
                    onClick={() => setExpanded(prevValue => !prevValue)}
                >
                    {expanded ? props.renderCollapseLabel(labelProps) : props.renderExpandLabel(labelProps)}
                </Button>
            </>
        )}
    </>;
}

export default ExpandableItemList;
